// Очистка классов в input "_success" и "_error"
export function inputCleaningErrorSuccess (fvcContainerId)
{
    const inputContainer = fvcContainerId.querySelectorAll('.input_container')
    inputContainer.forEach((input) => {
        if (input.classList.contains('_success')) input.classList.remove('_success');
        if (input.classList.contains('_error')) input.classList.remove('_error');

        // Удаляем дополнительный текст по ошибки
        const formAdditionalText = input.querySelector('.form_additional_text');
        if (formAdditionalText) formAdditionalText.remove();
    })
}

// Очистка классы "_error" по клику input в контейнере input_container
export function inputContainerClickRemoveError (e)
{
    const inputContainer = e.target.closest('.input_container')
    const formAdditionalText = inputContainer.querySelector('.form_additional_text')
    if (BX.hasClass(inputContainer, '_error')) {
        BX.removeClass(inputContainer, '_error')
        BX.remove(formAdditionalText)
    }
}

// Очистка классов в radio "_success" и "_error"
export function radioCleaningErrorSuccess (fvcContainerId)
{
    const radioWrapperToo = fvcContainerId.querySelector('.radio_wrapper_too');
    const radioControls = fvcContainerId.querySelectorAll('.radio_control_wrapper_js');

    if (radioWrapperToo) radioRemove(radioWrapperToo);

    if (radioControls) {
        radioControls.forEach(radio => {
            radioRemove(radio)
        })
    }

    function radioRemove (radioWrapperToo) {
        if (radioWrapperToo.classList.contains('_success')) radioWrapperToo.classList.remove('_success');
        if (radioWrapperToo.classList.contains('_error')) radioWrapperToo.classList.remove('_error');

        // Удаляем дополнительный текст по ошибки
        const formAdditionalText = radioWrapperToo.querySelector('.form_additional_text');
        if (formAdditionalText) formAdditionalText.remove();
    }

    /*if (radioWrapperToo) {
        if (radioWrapperToo.classList.contains('_success')) radioWrapperToo.classList.remove('_success');
        if (radioWrapperToo.classList.contains('_error')) radioWrapperToo.classList.remove('_error');

        // Удаляем дополнительный текст по ошибки
        const formAdditionalText = radioWrapperToo.querySelector('.form_additional_text');
        if (formAdditionalText) formAdditionalText.remove();
    }*/
}

// Очистка классов в input[tape=file] "_success" и "_error"
export function fileCleaningErrorSuccess (fvcContainerId)
{
    const fileWrapper = fvcContainerId.querySelector('.download_file_wrapper')

    if (fileWrapper) {
        const formAdditionalText = fileWrapper.querySelector('.form_additional_text');
        const viewFile = fileWrapper.querySelector('.view_file');
        const deleteFile = fileWrapper.querySelector('.delete_file');

        if (fileWrapper.classList.contains('_success')) fileWrapper.classList.remove('_success');
        if (fileWrapper.classList.contains('_error')) fileWrapper.classList.remove('_error');

        if (formAdditionalText) formAdditionalText.remove();
        if (viewFile) viewFile.remove();
        if (deleteFile) deleteFile.remove();
    }
}

// Html уведомления в контроллере input
export function messageHtml (mgs)
{
    return `
        <div class="form_additional_text">
            <i>!</i><span>${BX.message[mgs]}</span>
        </div>`;
}

// Html уведомления в страховке
export function mgsHtmlInsurance (mgs)
{
    let html = '';
    switch (mgs) {
        case 'REF_CODE':
            html = `<div class="cont_warning">
                        <div class="cw_title">${BX.message['STEP7_FORM_CW_TITLE']}</div>
                        <div class="cw_text">${BX.message['STEP7_FORM_CW_TEXT']}</div>
                    </div>`
            break;
        case 'REF_FALSE':
            html = `<div class="cont_warning">
                        <div class="cw_text_noo_ref">${BX.message['STEP7_FORM_CW_REF_NOO']}</div>
                    </div>`
            break;
    }

    return html;
}

// Html текст
export function htmlText (mgs)
{
    let html = '';
    switch (mgs) {
        case 'SUCCESS_VIEW_FILE':
            html = `<div class="view_file">
                        <span>${BX.message('SUCCESS_VIEW_FILE')}</span>
                    </div>`
            break;
        case 'SUCCESS_DELETE_FILE':
            html = `<div class="delete_file"><span>${BX.message('SUCCESS_DELETE_FILE')}</span></div>`
            break;
        case 'MODAL_DIALOG_IMG':
            html = '<div class="modal_dialog">' +
                        '<div class="modal_box">' +
                            '<a href="#" class="modal_close"><i class="fas fa-times"></i></a>' +
                            '<div class="img_preview"><img alt="img"></div>' +
                        '</div>' +
                    '</div>'
            break;
        case 'MODAL_DIALOG_MESSAGE_SENT':
            html = '<div class="modal_dialog">' +
                        '<div class="modal_box">' +
                            '<a href="javascript: void(0)" class="modal_close_end"></a>' +
                            '<div class="message_sent">' +
                                '<div class="ms_img"><img src="/img/form/ico_message_sent.png" alt="Ваша заявка отправлена"></div>' +
                                '<div class="ms_title">Благодарим вас!</div>' +
                                '<div class="ms_text">Ваша заявка отправлена.</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>'
            break;
        case 'MODAL_DIALOG_MESSAGE_SENT_PAY':
            html = '<div class="modal_dialog">' +
                        '<div class="modal_box">' +
                            '<a href="javascript: void(0)" class="modal_close_end"></a>' +
                            '<div class="message_sent spb">' +
                                '<div class="ms_img"><img src="/img/form/ico_message_sent.png" alt="Ваша заявка отправлена"></div>' +
                                '<div class="ms_title">Благодарим вас!</div>' +
                                '<div class="ms_text">Ожидаем Вашей оплаты</div>' +
                                '<div class="ms_img"><img src="/img/form/logo-spb.png" alt="Система быстрых платежей"></div>' +
                                '<div class="ms_text">При оплате через СБП мы получим Ваш платёж мгновенно<br>и приступим к выполнению Вашей заявки</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>'
            break;
        case 'MODAL_DIALOG_LOADER':
            html = `<div class="modal_dialog loader_js">
                        <div class="modal_loader">
                            <img src="/img/form/loader.gif" alt="loader">
                        </div>
                    </div>`
            break;
        case 'MODAL_DIALOG_ERROR':
            html = `<div class="modal_dialog">
                        <div class="modal_box _error">
                        <a href="javascript: void(0)" class="modal_close_end"></a>
                            <div class="message_sent">
                                <div class="ms_title">ERROR</div>
                                <div class="ms_text">
                                    На сайте проводятся работы,<br>
                                    повторите операцию позже.<br>
                                    Приносим свои извинения.
                                </div>
                            </div>
                        </div>
                    </div>            
                    `
            break;
    }

    return html;
}

// Html Разметка строки таблицы
export function tableRowHtml (name, prise, key)
{
    return `
        <div class="total_information_row" data-key="${key}">
            <div class="tir_text">${name}:</div>
            <div class="tir_prise">${prise}</div>
        </div>`;
}

// Html разметка общей суммы
export function tableTotalPriseHtml (prise)
{
    return `
        <div class="total_information_result">
            <div class="ti_res_text">Total:</div>
            <div class="ti_res_prise total_js">${prise}</div>
        </div>`;
}

// Добавляем класс если мобила
export function addClassMobile (ids, mobile)
{
    ids.forEach(id => {
        if (mobile) {
            id.classList.add('mobile_js')
        } else {
            if (id.classList.contains('mobile_js')) {
                id.classList.remove('mobile_js')
            }
        }
    })
}

// Меняем класс у родительских блоков на container-fluid
export function addClassMobileFluid (id, mobile)
{
    const contId = id.closest('#content')
    const containers = contId.querySelectorAll('.container_control_js');

    if (mobile) {
        containers.forEach(cont => {
            if (cont.classList.contains('nobottommargin') && cont.classList.contains('container')) {
                cont.classList.remove('container')
            }
            if (!cont.classList.contains('nobottommargin') && cont.classList.contains('container')) {
                cont.classList.remove('container')
                cont.classList.add('container-fluid')
            }
        })
    } else {
        containers.forEach(cont => {
            if (cont.classList.contains('nobottommargin') && !cont.classList.contains('container')) {
                cont.classList.add('container')
            }
            if (cont.classList.contains('container-fluid')) {
                cont.classList.remove('container-fluid')
                cont.classList.add('container')
            }
        })
    }
}

// Переключатель этапов в мобиле
export function controlNavMobileStep (model, navStepId, step)
{
    if (model) {
        const div = navStepId.querySelectorAll('.mobile_nav_step div')

        div.forEach(mns => {
            const mnsData = Number(mns.dataset.mns);
            if (step === mnsData) {
                mns.style.borderTop = '30px solid #1378BC'
            } else if (step > mnsData) {
                mns.style.borderTop = '30px solid #008526'
            } else {
                mns.style.borderTop = '30px solid #D6EEFF'
            }
        })
    }
}

// Контроль радио кнопки и добавление активного класса
export function setBorderControlRadioLoad (fvcContainerId)
{
    const radios = fvcContainerId.querySelectorAll('.radio_container input[type="radio"]');

    radios.forEach(radio => {
        const radioContainer = radio.closest('.radio_container')
        radioCheck(radio.checked, radioContainer)
        radio.addEventListener('click', function (e) {
            radioCheck(radio.checked, radioContainer, radios, e.target)
        })
    })

    function radioCheck (checked, radioContainer, radios=false, target=false) {
        let radioGroup = false;

        if (target) radioGroup = target.closest('.radio_group_js');

        if (radioGroup) {
            const radioCont = radioGroup.querySelectorAll('.radio_container')
            radioCont.forEach(radio => {
                if (radio.classList.contains('active')) {
                    radio.classList.remove('active');
                }
            })
        } else {
            if (radios) {
                radios.forEach(radio => {
                    const radContainer = radio.closest('.radio_container')
                    if (radContainer.classList.contains('active')) {
                        radContainer.classList.remove('active');
                    }
                })
            }
        }


        if (checked) {
            if (!radioContainer.classList.contains('active')) {
                radioContainer.classList.add('active');
            }
        }
    }


}

// step2 - включена "Бизнес виза" на step1: добавляем новые поля в DOM
export function setStep2BusinessContainerHtml(proxy, dataLS)
{
    // Business visa
    let inputCompanyActivity = '';
    if (dataLS.businessVisa && dataLS.businessVisa['companyActivity']) {
        inputCompanyActivity = dataLS.businessVisa['companyActivity']
    }

    let inputCompanyZipCodeAddress = ''
    if (dataLS.businessVisa && dataLS.businessVisa['companyZipCodeAddress']) {
        inputCompanyZipCodeAddress = dataLS.businessVisa['companyZipCodeAddress']
    }

    let inputCompanyWebsite = ''
    if (dataLS.businessVisa && dataLS.businessVisa['companyWebsite']) {
        inputCompanyWebsite = dataLS.businessVisa['companyWebsite']
    }

    let inputCompanyPhone = ''
    if (dataLS.businessVisa && dataLS.businessVisa['companyPhone']) {
        inputCompanyPhone = dataLS.businessVisa['companyPhone']
    }

    let inputCompanyEmail = ''
    if (dataLS.businessVisa && dataLS.businessVisa['companyEmail']) {
        inputCompanyEmail = dataLS.businessVisa['companyEmail']
    }

    let inputCompanyPurposeTrip = ''
    if (dataLS.businessVisa && dataLS.businessVisa['companyPurposeTrip']) {
        inputCompanyPurposeTrip = dataLS.businessVisa['companyPurposeTrip']
    }

    let inputCompanyPreviousYearsWork = ''
    if (dataLS.businessVisa && dataLS.businessVisa['companyPreviousYearsWork']) {
        inputCompanyPreviousYearsWork = dataLS.businessVisa['companyPreviousYearsWork']
    }


    const formBusinessContainer = proxy.fvcContainerId.querySelector('.formBusinessContainer')

    if (!formBusinessContainer)
    {
        const companyActivity = BX.create({
            tag:'div',
            props: {
                className: "input_container"
            },
            children: [
                BX.create({
                    tag: 'label',
                    attrs: {for: '383', className: 'form_label'},
                    text: proxy.message.STEP2_COMPANY_ACTIVITY
                }),
                BX.create({
                    tag: 'span',
                    props: {className:'ico_input organization'}
                }),
                BX.create({
                    tag: 'span',
                    props: {className:'check_ico'}
                }),
                BX.create({
                    tag: 'input',
                    attrs: {
                        id: '383',
                        type:'text',
                        className:'input_box input_control_js',
                        placeholder:'',
                        value: inputCompanyActivity,
                        required: true,
                    },
                    dataset: {
                        name: 'companyActivity',
                        subName: 'businessVisa'
                    }
                }),
            ]
        })
        const companyZipCodeAddress = BX.create({
            tag:'div',
            props: {
                className: "input_container"
            },
            children: [
                BX.create({
                    tag: 'label',
                    attrs: {for: '384', className: 'form_label'},
                    text: proxy.message.STEP2_COMPANY_ZIP_CODE_ADDRESS
                }),
                BX.create({
                    tag: 'span',
                    props: {className:'ico_input location'}
                }),
                BX.create({
                    tag: 'span',
                    props: {className:'check_ico'}
                }),
                BX.create({
                    tag: 'input',
                    attrs: {
                        id: '384',
                        type:'text',
                        className:'input_box input_control_js',
                        placeholder:'',
                        value: inputCompanyZipCodeAddress,
                        required: true,
                    },
                    dataset: {
                        name: 'companyZipCodeAddress',
                        subName: 'businessVisa'
                    }
                }),
            ]
        })
        const companyWebsite = BX.create({
            tag:'div',
            props: {
                className: "input_container"
            },
            children: [
                BX.create({
                    tag: 'label',
                    attrs: {for: '385', className: 'form_label'},
                    text: proxy.message.STEP2_COMPANY_WEBSITE
                }),
                BX.create({
                    tag: 'span',
                    props: {className:'ico_input organization'}
                }),
                BX.create({
                    tag: 'span',
                    props: {className:'check_ico'}
                }),
                BX.create({
                    tag: 'input',
                    attrs: {
                        id: '385',
                        type:'text',
                        className:'input_box input_control_js',
                        placeholder:'',
                        value: inputCompanyWebsite,
                    },
                    dataset: {
                        name: 'companyWebsite',
                        subName: 'businessVisa'
                    }
                }),
            ]
        })
        const companyPhone = BX.create({
            tag:'div',
            props: {
                className: "input_container"
            },
            children: [
                BX.create({
                    tag: 'label',
                    attrs: {for: '386', className: 'form_label'},
                    text: proxy.message.STEP2_COMPANY_PHONE
                }),
                BX.create({
                    tag: 'span',
                    props: {className:'ico_input phone'}
                }),
                BX.create({
                    tag: 'span',
                    props: {className:'check_ico'}
                }),
                BX.create({
                    tag: 'input',
                    attrs: {
                        id: '386',
                        type:'text',
                        className:'input_box input_control_js',
                        placeholder:'',
                        value: inputCompanyPhone,
                        required: true,
                    },
                    dataset: {
                        name: 'companyPhone',
                        subName: 'businessVisa',
                        exception: true
                    }
                }),
            ]
        })
        const companyEmail = BX.create({
            tag:'div',
            props: {
                className: "input_container"
            },
            children: [
                BX.create({
                    tag: 'label',
                    attrs: {for: '387', className: 'form_label'},
                    text: proxy.message.STEP2_COMPANY_EMAIL
                }),
                BX.create({
                    tag: 'span',
                    props: {className:'ico_input email'}
                }),
                BX.create({
                    tag: 'span',
                    props: {className:'check_ico'}
                }),
                BX.create({
                    tag: 'input',
                    attrs: {
                        id: '387',
                        type:'text',
                        className:'input_box input_control_js',
                        placeholder:'',
                        value: inputCompanyEmail,
                        required: true,
                    },
                    dataset: {
                        name: 'companyEmail',
                        subName: 'businessVisa',
                        exception: true
                    }
                }),
            ]
        })
        const companyPurposeTrip = BX.create({
            tag:'div',
            props: {
                className: "input_container"
            },
            children: [
                BX.create({
                    tag: 'label',
                    attrs: {for: '388', className: 'form_label'},
                    text: proxy.message.STEP2_COMPANY_PURPOSE_TRIP
                }),
                BX.create({
                    tag: 'span',
                    props: {className:'check_ico'}
                }),
                BX.create({
                    tag: 'textarea',
                    attrs: {
                        id: '388',
                        style: 'resize:none; height:auto; width:100%; padding-left:14px;',
                        rows: '3',
                        className:'input_box input_control_js',
                        placeholder:'',
                        required: true,
                    },
                    text: inputCompanyPurposeTrip,
                    dataset: {
                        name: 'companyPurposeTrip',
                        subName: 'businessVisa',
                        exception: true
                    },
                    events: {
                        click: BX.proxy(proxy.fn.inputContainerClickRemoveError, this)
                    },
                }),
            ]
        })
        const companyPreviousYearsWork = BX.create({
            tag:'div',
            props: {
                className: "input_container"
            },
            children: [
                BX.create({
                    tag: 'label',
                    attrs: {for: '389', className: 'form_label'},
                    text: proxy.message.STEP2_COMPANY_PREVIOUS_PLACE_YEARS_WORK
                }),
                BX.create({
                    tag: 'span',
                    props: {className:'ico_input profession'}
                }),
                BX.create({
                    tag: 'span',
                    props: {className:'check_ico'}
                }),
                BX.create({
                    tag: 'input',
                    attrs: {
                        id: '389',
                        type:'text',
                        className:'input_box input_control_js',
                        placeholder:'',
                        value: inputCompanyPreviousYearsWork,
                        required: true,
                    },
                    dataset: {
                        name: 'companyPreviousYearsWork',
                        subName: 'businessVisa',
                        exception: true
                    }
                }),
            ]
        })

        const formBusinessContainer = BX.create({
            tag:'div',
            props: {
                className: "formBusinessContainer"
            },
            children: [
                companyActivity,
                companyZipCodeAddress,
                companyWebsite,
                companyPhone,
                companyEmail,
                companyPurposeTrip,
                companyPreviousYearsWork
            ]
        })

        const fpiInputWrapper = proxy.fvcContainerId.querySelector('.fpi_input_wrapper')
        BX.append(formBusinessContainer, fpiInputWrapper)
    }
}